import { useEffect, useMemo, useState } from 'react';

import type { HeroFeedItem } from 'src/app/pages/promote/pageContext';
import { usePromotePageData } from 'src/app/pages/promote/pageContext';

type Props = {
	pillDisplayedCountMin: number;
};

type Result = ModelHookResult<{
	displayedItems: readonly HeroFeedItem[];
	animateSpeed: number;
	animateDelay: number;
}>;

const ANIMATE_DELAY = 2000;
const ANIMATE_SPEED = 2000;
const PILL_DISPLAYED_COUNT_MAX = 4;

export function useHeroFeed({ pillDisplayedCountMin }: Props = { pillDisplayedCountMin: 2 }): Result {
	const {
		data: {
			petition: {
				feeds: { heroFeed },
			},
		},
	} = usePromotePageData();

	const [items, setItems] = useState(() => heroFeed.toReversed());

	useEffect(() => {
		if (items.length <= pillDisplayedCountMin) {
			return undefined;
		}

		const timeout = window.setTimeout(() => {
			setItems(items.slice(1));
		}, ANIMATE_DELAY + ANIMATE_SPEED);
		return () => {
			window.clearTimeout(timeout);
		};
	}, [items, pillDisplayedCountMin]);

	const itemsTruncated = useMemo(() => items.slice(0, PILL_DISPLAYED_COUNT_MAX), [items]);

	return {
		data: {
			displayedItems: itemsTruncated,
			animateSpeed: ANIMATE_SPEED,
			animateDelay: ANIMATE_DELAY,
		},
	};
}
